import { Notification, NotificationType } from "../../core/entities/notification";
import { ADD_NOTIFICATION_REQUEST, ADD_NOTIFICATION_SUCCESS, ADD_NOTIFICATION_FAILURE, CLEAR_NOTIFICATION_VALUES, FETCH_NOTIFICATION_REQUEST, FETCH_NOTIFICATION_SUCCESS, FETCH_NOTIFICATION_FAILURE, UPDATE_NOTIFICATION_REQUEST, UPDATE_NOTIFICATION_SUCCESS, UPDATE_NOTIFICATION_FAILURE, FETCH_NOTIFICATION_COUNT_REQUEST, FETCH_NOTIFICATION_COUNT_SUCCESS, FETCH_NOTIFICATION_COUNT_FAILURE, RESET_NOTIFICATIONS_STATE } from './actionType';
import { initiateRequest } from './../request/action';

export const addNotificationRequest = (notification: NotificationType) =>
  initiateRequest({
    type: ADD_NOTIFICATION_REQUEST,
    payload: { notification }
  });

export const addNotificationSuccess = () => ({
  type: ADD_NOTIFICATION_SUCCESS,
});

export const addNotificationFailure = (error: string) => ({
  type: ADD_NOTIFICATION_FAILURE,
  payload: { error },
});

export const clearNotificationValues = () => ({
  type: CLEAR_NOTIFICATION_VALUES,
});

export const fetchNotifications = (
  where?: [
    string,
    "<" | "<=" | "==" | ">=" | ">" | "!=" | "in",
    string | number | boolean | null | Date | Array<any>
  ][],
  startAt?: any,
  limit?: number
) => initiateRequest({
  type: FETCH_NOTIFICATION_REQUEST,
  payload: { where, startAt, limit }
});

export const fetchNotificationsSuccess = (notifications: Notification[]) => ({
  type: FETCH_NOTIFICATION_SUCCESS,
  payload: { notifications },
});

export const fetchNotificationsFailure = (error: string) => ({
  type: FETCH_NOTIFICATION_FAILURE,
  payload: { error },
});

export const updateNotificationRequest = (id: string, notification: any) =>
  initiateRequest({
    type: UPDATE_NOTIFICATION_REQUEST,
    payload: { id, notification }
  });

export const updateNotificationSuccess = () => ({
  type: UPDATE_NOTIFICATION_SUCCESS,
});

export const updateNotificationFailure = (error: string) => ({
  type: UPDATE_NOTIFICATION_FAILURE,
  payload: { error },
});

export const fetchNotificationsCount = (
  isAdmin?: boolean,
  where?: [
    string,
    "<" | "<=" | "==" | ">=" | ">" | "!=" | "in",
    string | number | boolean | null | Date | Array<any>
  ][],
  startAfter?: unknown,
  limit?: number
) => initiateRequest({
  type: FETCH_NOTIFICATION_COUNT_REQUEST,
  payload: { isAdmin, where, startAfter, limit }
});

export const fetchNotificationsCountSuccess = (count: number) => ({
  type: FETCH_NOTIFICATION_COUNT_SUCCESS,
  payload: { count },
});

export const fetchNotificationsCountFailure = (error: string) => ({
  type: FETCH_NOTIFICATION_COUNT_FAILURE,
  payload: { error },
});

export const resetNotificationsState = () => ({
  type: RESET_NOTIFICATIONS_STATE
});
